if (!customElements.get("kit-variant-metafield-select")) {
  customElements.define(
    "kit-variant-metafield-select",
    class KitVariantMetafields extends HTMLElement {
      constructor() {
        super();
        this.metafieldOptions = ["mortar_collar", "storm_collar", "top_clamp", "adapter", "tee_end_cap", "tee_snout", "tee_body", "top_plate", "lid_cap"];

        this.customProperties = {};
        this.kitData = null;
        this.init();
      }

      init() {
        this.updateProperties();
        this.attachEventListeners();

        // Read current values after everything has loaded
        setTimeout(() => {
          this.readCurrentFieldValues();
        }, 100);
      }

      readCurrentFieldValues() {
  // Simply read the current state of all visible fields
  const fields = ['diameter', 'length', 'sheathing_type', 'adapter', 'tee_end_cap', 'tee_snout', 'tee_body', 'top_plate', 'lid_cap'];

  fields.forEach(id => {
    const element = document.getElementById(id);
    if (element) {
      // For selects: buscar la opción visualmente seleccionada
      if (element.tagName === 'SELECT') {
        // Buscar la opción que realmente está seleccionada visualmente
        const visuallySelected = Array.from(element.options).find(option => 
          option.selected || option.hasAttribute('selected')
        );
        
        if (visuallySelected && visuallySelected.value) {
          this.defaultProperties[id] = visuallySelected.value;
        } else if (element.value) {
          // Fallback al value normal
          this.defaultProperties[id] = element.value;
        }
      }
      // For buttons: take the one with the active class
      else if (element.classList.contains('active')) {
        this.defaultProperties[id] = element.textContent.trim() || element.value;
      }
    }
  });

  console.log("Current field values read:", this.defaultProperties);
}
      captureInitialValues() {
        const elementsToCheck = ['diameter', 'length', 'sheathing_type', 'adapter', 'top_plate', 'lid_cap'];

        elementsToCheck.forEach(id => {
          const element = document.getElementById(id);
          if (element) {
            if (element.tagName === 'SELECT' && element.selectedIndex >= 0) {
              const selectedOption = element.options[element.selectedIndex];
              if (selectedOption && selectedOption.value) {
                this.defaultProperties[id] = selectedOption.value;
              }
            }
            else if (element.classList.contains('active') || element.checked) {
              this.defaultProperties[id] = element.value || element.textContent.trim();
            }
          }
        });

        console.log("Initial values captured:", this.defaultProperties);
      }

      // Retrieve variant and customer IDs
      get variantNetsuiteId() {
        return document.getElementById("kit-variant-netsuite-id")?.value || null;
      }

      get customerId() {
        return document.getElementById("kit-product")?.dataset?.customerid || null;
      }

      // Update metafield properties dynamically
      updateProperties() {
        console.log("=== DEBUGGING METAFIELDS ===");

        this.defaultProperties = this.metafieldOptions.reduce((props, id) => {
          const element = document.getElementById(id);
          console.log(`ID: ${id}`, {
            element: element,
            value: element?.value,
            textContent: element?.textContent,
            dataset: element?.dataset
          });

          if (element?.value.trim()) {
            props[id] = element.value.trim();
          }
          return props;
        }, {});

        console.log("Final defaultProperties:", this.defaultProperties);
        this.toggleButtons();
      }

      // Attach event listeners
      attachEventListeners() {
        this.attachFieldListeners();
        this.attachCalculatePriceListener();
        this.attachAddToCartListener();
      }

      attachFieldListeners() {
        this.metafieldOptions.forEach((key) => {
          const selectElement = document.getElementById(key);
          if (selectElement) {
            selectElement.addEventListener("change", () => {
              this.updateProperties();
            });
          }
        });
      }

      attachCalculatePriceListener() {
        const calculatePriceBtn = document.querySelector(".calculate__price");
        if (calculatePriceBtn) {
          calculatePriceBtn.addEventListener("click", async (e) => {
            e.preventDefault();
            if (!this.isCustomerLoggedIn()) return;

            this.toggleLoading(true, calculatePriceBtn);

            try {
              await this.fetchPrice();
            } catch (error) {
              console.error("Error fetching price:", error);
              this.showError(`Error calculating price: ${error.message}`);
            } finally {
              this.toggleLoading(false, calculatePriceBtn);
            }
          });
        }
      }

      attachAddToCartListener() {
        const addToCartButton = document.getElementById("custom_add-btn");
        if (addToCartButton) {
          addToCartButton.addEventListener("click", async (e) => {
            e.preventDefault();

            const variantId = addToCartButton.dataset.variant;
            this.customProperties = { ...this.defaultProperties, base_price: document.querySelector("#price__property")?.value };

            this.toggleLoading(true, addToCartButton);

            try {
              const cart = await this.fetchCart();
              const data = this.buildCartData(variantId, cart);

              await this.addToCart(data);
            } catch (error) {
              console.error("Error adding to cart:", error);
              this.showError(`Error adding to cart: ${error.message}`);
            } finally {
              this.toggleLoading(false, addToCartButton);
            }
          });
        }
      }

      async fetchCart() {
        try {
          const response = await fetch("/cart.js");
          return await response.json();
        } catch (error) {
          console.error("Error fetching cart:", error);
          throw new Error("Could not fetch cart data");
        }
      }

      buildCartData(variantId, cart) {
        const quantityValue = parseInt(document.querySelector(".quantity__input")?.value, 10) || 1;
        const variantIdInt = parseInt(variantId);

        const matchingVariant = cart.items.find((item) => item.variant_id === variantIdInt);

        if (matchingVariant) {
          const propertiesMatch = this.metafieldOptions.every((prop) => {
            return (matchingVariant.properties[prop] || "") === (this.customProperties[prop] || "");
          });

          if (!propertiesMatch) {
            this.customProperties.unique_id = Date.now().toString();
          }
        }

        return {
          id: variantIdInt,
          quantity: quantityValue,
          properties: {
            ...this.customProperties,
            _kit_data: typeof this.kitData === 'object' ? JSON.stringify(this.kitData) : ''
          }
        };
      }

      async addToCart(data) {
        try {
          const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data),
          });

          if (!response.ok) {
            throw new Error(await response.text());
          }

          console.log("Item added to cart:", await response.json());
          window.location.href = "/cart";
        } catch (error) {
          console.error("Error adding to cart:", error);
          this.showError(`Failed to add item to cart: ${error.message}`);
        }
      }

      validateDataForBoomi() {
        const requiredFields = {
          variantNetsuiteId: this.variantNetsuiteId,
          customerId: this.customerId
        };

        const missingFields = Object.entries(requiredFields)
          .filter(([key, value]) => !value || value === 'null' || value === 'undefined')
          .map(([key]) => key);

        if (missingFields.length > 0) {
          throw new Error(`Missing required fields for Boomi: ${missingFields.join(', ')}`);
        }

        if (isNaN(this.variantNetsuiteId) || this.variantNetsuiteId <= 0) {
          throw new Error("NetSuite Variant ID must be a valid number");
        }

        return true;
      }

      buildBoomiPayload() {
        const payload = {
          item: this.variantNetsuiteId,
          customer: this.customerId,
          request_timestamp: new Date().toISOString(),
          ...this.defaultProperties
        };

        const kitDataInput = document.getElementById('kit-data-json');
        if (kitDataInput && kitDataInput.value) {
          try {
            let kitData = this.parseKitData(kitDataInput.value);

            if (kitData && Object.keys(kitData).length > 0) {
              Object.assign(payload, kitData);
              console.log("Kit data added to payload:", kitData);
            }
          } catch (e) {
            console.warn('Error processing kit_data, continuing without it:', e);
          }
        }

        console.log("Final Payload for Boomi:", payload);
        return payload;
      }

      parseKitData(rawData) {
        let kitData = {};
        try {
          let parsedData = rawData;

          // Handle multiple levels of stringify
          while (typeof parsedData === 'string') {
            parsedData = JSON.parse(parsedData);
          }

          // Process arrays and extract first valid value
          kitData = Object.fromEntries(
            Object.entries(parsedData).map(([key, val]) => {
              if (Array.isArray(val)) {
                const firstValid = val.find(v => v !== null && v !== undefined && v !== '');
                return [key, firstValid || ''];
              }
              return [key, val || ''];
            })
          );

        } catch (e) {
          console.error('Error parsing kit_data:', e);
          throw new Error(`Invalid kit_data format: ${e.message}`);
        }

        return kitData;
      }

      async validateBoomiConnection(endpoint, token) {
        try {
          // Basic connectivity test
          const testPayload = {
            item: this.variantNetsuiteId,
            customer: this.customerId,
            test_connection: true,
            timestamp: new Date().toISOString()
          };

          const response = await axios.post(endpoint, testPayload, {
            headers: {
              Authorization: `Basic ${btoa(token)}`,
              "Content-Type": "application/json",
            },
            timeout: 10000 // 10 second timeout
          });

          if (response.status !== 200) {
            throw new Error(`Boomi connection test failed: ${response.status}`);
          }

          console.log("Boomi connection validated successfully");
          return true;
        } catch (error) {
          console.error("Boomi connection validation failed:", error);
          throw new Error(`Connection test failed: ${error.message}`);
        }
      }

      async fetchPrice() {
        const optionsWrapper = this.closest(".kit__options-wrapper");
        if (!optionsWrapper) {
          this.showError("Config error: no wrapper found");
          return;
        }

        const { token, url: endpoint } = optionsWrapper.dataset;

        if (!token || !endpoint) {
          this.showError("Config error: missing endpoint");
          return;
        }

        try {
          // MANDATORY PRE-VALIDATIONS
          this.validateDataForBoomi();

          // Optional: Connectivity test (comment out if it causes issues)
          // await this.validateBoomiConnection(endpoint, token);

          // Build validated payload
          const payload = this.buildBoomiPayload();

          console.log("Sending request to Boomi:", payload);

          const response = await axios.post(endpoint, payload, {
            headers: {
              Authorization: `Basic ${btoa(token)}`,
              "Content-Type": "application/json",
            },
            timeout: 25000 //
          });

          if (response.status === 200) {
            if (response.data?.price) {
              this.updatePrice(response.data.price);
              console.log("Price updated successfully:", response.data.price);
            } else {
              console.warn("No response received, using fallback");
              this.updatePrice(700.49); // Fallback price
            }

            // Save kit_data from the response
            if (response.data?.kit_data) {
              this.kitData = response.data.kit_data;
              console.log("Kit data received:", this.kitData);
            }

            this.showError(false);
          } else {
            throw new Error(`Request failed with status: ${response.status}`);
          }
        } catch (error) {
          console.error("Error fetching price:", error);

          // Show more specific error message
          let errorMessage = "Error retrieving price";
          if (error.message.includes("Missing required fields")) {
            errorMessage = "Incomplete data. Please check the product configuration.";
          } else if (error.message.includes("Connection test failed")) {
            errorMessage = "Server connection error. Please try again.";
          } else if (error.code === 'ECONNABORTED') {
            errorMessage = "Timeout: The server took too long to respond.";
          } else if (error.response?.status === 401) {
            errorMessage = "Authentication error. Please contact the administrator.";
          } else if (error.response?.status >= 500) {
            errorMessage = "Server error. Please try again in a few moments.";
          }

          this.showError(errorMessage);
        }
      }

      kitData(data) {
        this.kitData = data;
      }

      updatePrice(price) {
        const formattedPrice = `${Number(price).toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;

        document.querySelector("#price__property").value = Number(price).toFixed(2);
        document.querySelector(".price-item span").textContent = `$${formattedPrice}`;

        document.getElementById("custom_add-btn").style.display = "flex";
        document.querySelector(".calculate__price").style.display = "none";
      }

      toggleButtons() {
        const calculatePriceBtn = document.querySelector(".calculate__price");
        const addToCartButton = document.getElementById("custom_add-btn");

        if (calculatePriceBtn) calculatePriceBtn.style.display = "flex";
        if (addToCartButton) addToCartButton.style.display = "none";
      }

      toggleLoading(isLoading, button) {
        const loader = button.querySelector(".btn-ring");
        if (loader) loader.style.display = isLoading ? "block" : "none";
        button.disabled = isLoading;
      }

      showError(message = "") {
        const fetchError = document.querySelector(".boomi__error-popup");
        if (fetchError) {
          fetchError.style.display = message ? "block" : "none";
          if (message) {
            fetchError.textContent = message;
          }
        } else {
          // Fallback if error popup doesn't exist
          if (message) {
            console.error("Error popup not found. Error message:", message);
            alert(message); // Temporary - replace with your notification system
          }
        }
      }

      isCustomerLoggedIn() {
        if (!this.customerId) {
          const loginPopup = document.querySelector(".customer_login_popup");
          if (loginPopup) {
            loginPopup.style.display = "block";
          }
          console.warn("Customer not logged in. Redirecting...");
          setTimeout(() => {
            window.location.href = "/account/login";
          }, 2000);
          return false;
        }
        return true;
      }
    }
  );
}